const aws_region = "us-east-1";

const config = {
  appName: "Trust UI - Prod",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_eQxmQPK4z`,
    domain: `ispp-trust-co-token-prd.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://ispp-trust-co-token-prd.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "ispp-trust-co-identity-provider",
    redirectUrl: "https://citplanmanager.am.principal.com",
    clientId: "7uocfh7bvi7v0cadho5snomk0h",
    scope: "ispp-trust-co-resource-server/read-write",
    readOnlyGroup: "trust-co-read-only-client",
    updateGroup: "ispp-trust-co-read-write-client",
  },
  api: {
    baseUrl: `https://zjazki4yye.execute-api.${aws_region}.amazonaws.com/prod/api`,
  },
};

export default config;
